import axios from '../../localAxios';
import { workspaceFolderURL } from '../workspacesURLs';
import { WorkspaceFolder } from './types';

export type UpdateWorkspaceFolderResponse = WorkspaceFolder;
export type UpdateWorkspaceFolderParameters = {
  name: string;
  workspaceId: string;
  workspaceFolderId: string;
};

export async function updateWorkspaceFolder({
  name,
  workspaceId,
  workspaceFolderId,
}: UpdateWorkspaceFolderParameters) {
  const url = workspaceFolderURL({
    workspaceId,
    workspaceFolderId: workspaceFolderId,
  });
  const response = await axios.put<UpdateWorkspaceFolderResponse>(url.href, {
    name,
  });
  return response.data;
}
